import { Box, Checkbox, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import groupBy from "../../../../../../helpers/groupBy";
import { IDataExpedirItem } from "../../../../../../types/api/estoque/pesquisar-itens-para-expedir";
import EditIcon from '@mui/icons-material/Edit';
import { useState } from "react";
import { IDataDetalheExpItem } from "../../../../../../types/api/estoque/detalhar-expedicao";
import DialogEditPedidoSeparacao from "../DialogEditPedidoSeparacao";

export default function Step02() {

    const [openEditItem, setOpenEditItem] = useState<IDataDetalheExpItem | null>(null)
    const { watch, getValues, setValue } = useFormContext()

    const grouped = groupBy(getValues('itens'), (i) => i.produto.departamento);
    const selectedItems: IDataExpedirItem[] = watch("itensSelecionados")
    
    //funções manipuladoras
    const handleEditItem = (item: IDataExpedirItem) => {
        setOpenEditItem({
            id: item.id,
            produto: {
                codigo: item.produto.codigo,
                nome: item.produto.nome,
                departamento: item.produto.departamento,
                setor: item.produto.setor,
                estoque_atual: item.estoque_atual,
                exige_lote: item.exige_lote,
                qtd_separar: item.quantidade_solicitada > item.estoque_atual ? item.estoque_atual : item.quantidade_solicitada,
                encomenda_solicitada: item.encomenda_solicitada,
                lotes_selecionados: item.lotes_indicados,
                lotes_disponiveis: item.lotes
            }
        });
        const selectedItemsIds = selectedItems.map((item: IDataExpedirItem) => item.id);
        const contemItem = selectedItemsIds.includes(item.id)
        if (contemItem) {
            handleCheckboxChange(item);
        }
    }

    const handleCheckboxChange = (item: IDataExpedirItem) => {
        const selectedItemsIds = selectedItems.map((item: IDataExpedirItem) => item.id);

        const contemItem = selectedItemsIds.includes(item.id)

        if (contemItem) setValue('itensSelecionados', selectedItems.filter((selectedItem: IDataExpedirItem) => selectedItem.id !== item.id));
        if (!contemItem) setValue('itensSelecionados', [...selectedItems, item])
    }

    const handleCheckGroupBox = (checked: boolean, departamento: string) => {
        const itens: IDataExpedirItem[] = grouped[departamento]
        let updatedItems: IDataExpedirItem[] = []

        if (checked) {
            const newItems = itens.filter((newItem) => !selectedItems.some((selectedItem) => selectedItem.id === newItem.id));
            updatedItems = [...selectedItems, ...newItems];
        }
        if (!checked) {
            const itemsToRemove = selectedItems.filter((selectedItem) => selectedItem.produto.departamento === departamento);
            updatedItems = selectedItems.filter((selectedItem) => !itemsToRemove.includes(selectedItem));
        }

        setValue('itensSelecionados', updatedItems);
    }
    //

    return (
        <>
            {
                Object.keys(grouped).map((key) => {
                    const items = grouped[key];
                    const existeDepartamento = selectedItems.some((item) => item.produto.departamento === key);

                    return (
                        <Box mt={2}>
                            <Typography variant="body1">{key}</Typography>
                            <TableContainer>
                                <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell width={50}>
                                                <Checkbox
                                                    checked={existeDepartamento}
                                                    onChange={(e) => handleCheckGroupBox(e.target.checked, key)}
                                                />
                                            </TableCell>
                                            <TableCell>Produto</TableCell>
                                            <TableCell width={110} align="right">Estoque solicitante</TableCell>
                                            <TableCell width={110} align="right">Estoque origem</TableCell>
                                            <TableCell width={160} align="right">Solicitado</TableCell>
                                            <TableCell width={110} align="right">Separar</TableCell>
                                            <TableCell width={110} ></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            items.map((i: IDataExpedirItem, index: number) => {
                                                const checked = selectedItems.some((item: IDataExpedirItem) => item.id === i.id)

                                                return (
                                                    <TableRow
                                                        key={index}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell>
                                                            <Checkbox
                                                                checked={checked}
                                                                onChange={() => handleCheckboxChange(i)}
                                                            />
                                                        </TableCell>

                                                        <TableCell>
                                                            <Typography>{i.produto.nome}</Typography>
                                                            <Typography variant="caption">Cód: {i.produto.codigo} / Setor: {i.produto.setor}</Typography>
                                                        </TableCell>

                                                        <TableCell align="right">
                                                            {i.estoque_solicitante}
                                                        </TableCell>

                                                        <TableCell align="right">
                                                            {i.estoque_atual}
                                                        </TableCell>

                                                        <TableCell align="right">
                                                            
                                                            <Typography fontSize={'0.875rem'}>{i.quantidade_solicitada}</Typography>
                                                            {
                                                                i.encomenda_solicitada > 0 &&
                                                                <Typography variant="caption">Sendo {i.encomenda_solicitada} encomenda</Typography>
                                                            }

                                                        </TableCell>

                                                        <TableCell align="right">
                                                            {watch(`itens[${index}].quantidade`)}
                                                        </TableCell>
                                                        <TableCell align="right">

                                                            <IconButton onClick={() => handleEditItem(i)}>
                                                                <EditIcon />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            })
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    )
                })
            }
            {
                openEditItem &&
                <DialogEditPedidoSeparacao
                    open={openEditItem}
                    handleClose={() => setOpenEditItem(null)}
                />
            }
        </>
    )
}